module.exports = __webpack_public_path__ + "static/legacy-603268ebb1667cca3f9d17ba4144a024.png";